import useMinWidth from '@/hooks/useMinWidth'

export function useIsMinWidthLg() {
  return useMinWidth('lg')
}
